import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'

export default {
  getCheckoutSession () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/memberPlan/create-checkout-session',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getMemberPlanInfo () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'memberPlan/info',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          const {
            resultCode,
            message
          } = response.data.header
          if (resultCode !== code.success && resultCode !== code.noRecordFound) {
            reject(message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getConfirmUssageInfo () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'memberPlan/confirm-ussage',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          const {
            resultCode,
            message
          } = response.data.header
          if (resultCode !== code.success && resultCode !== code.noRecordFound) {
            reject(message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getCustomerPortalSession () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/memberPlan/create-customer-portal-session',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  checkCancelSubscription () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/memberPlan/cancel-subscription',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  cancelSubscription () {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/memberPlan/cancel-subscription',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/memberplanservice.js